<template>
    <div class="tw-mt-3 tw-flex tw-flex-col tw-gap-3">
        <slot></slot>
    </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
